// extracted by mini-css-extract-plugin
export default {"locationsPage":"Locations_locationsPage__gcIKK","locationsGrid":"Locations_locationsGrid__3IyiN","nameLink":"Locations_nameLink__ZDmPU"};